var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-container", attrs: { id: "chat-view-tracking" } },
    [
      _c("div", { staticClass: "chat-header" }, [
        _c("div", { staticClass: "status" }, [
          _c("span", { staticClass: "timer" }, [
            _vm._v(
              _vm._s(
                _vm.getTimeDifference(
                  new Date(),
                  Date.parse(_vm.ticket.createdAt)
                )
              )
            )
          ]),
          _c("span", { staticClass: "active" }, [
            _vm._v(_vm._s(_vm.ticket.status))
          ])
        ]),
        _c("div", { staticClass: "info" }, [
          _c("span", { staticClass: "message-id" }, [
            _vm._v(_vm._s(_vm.ticket.id))
          ]),
          _c("span", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.ticket.assigneeName))
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "chat-body", attrs: { id: "scrollable-container" } },
        _vm._l(_vm.messages, function(message, index) {
          return _c(
            "div",
            {
              key: index,
              class: [
                "message",
                message.userId === _vm.getProfile.id ? "you" : "other"
              ]
            },
            [
              _c("div", { staticClass: "sender" }, [
                message.userId !== _vm.getProfile.id
                  ? _c(
                      "span",
                      [
                        _vm._v(" " + _vm._s(message.userName) + " "),
                        _c(
                          "router-link",
                          {
                            staticClass: "message-id",
                            attrs: {
                              to: {
                                name: "captains.show",
                                params: { id: message.userId }
                              }
                            }
                          },
                          [_c("span", [_vm._v(_vm._s(message.userId))])]
                        )
                      ],
                      1
                    )
                  : _c("span", [_vm._v(_vm._s(message.userName))])
              ]),
              _c("div", { staticClass: "message-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "text",
                    class: {
                      "text-you": message.userId === _vm.getProfile.id,
                      "text-other": message.userId !== _vm.getProfile.id
                    }
                  },
                  [_vm._v(" " + _vm._s(message.text) + " ")]
                ),
                _c("div", { staticClass: "timestamp" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("moment")(message.createdAt, "Y-MM-DD hh:mm:ss A")
                    )
                  )
                ])
              ])
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "chat-input" }, [
        _vm.ticket.status == "ACTIVE" &&
        _vm.ticket.assigneeId != null &&
        _vm.ticket.assigneeId != undefined &&
        _vm.ticket.assigneeId === _vm.getProfile.id
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newMessage,
                  expression: "newMessage"
                }
              ],
              staticClass: "input",
              attrs: {
                type: "text",
                disabled: _vm.ticket.status != "ACTIVE",
                placeholder: "Type your message here."
              },
              domProps: { value: _vm.newMessage },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.sendMessage($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newMessage = $event.target.value
                }
              }
            })
          : _vm._e(),
        _vm.ticket.assigneeId != _vm.getProfile.id
          ? _c(
              "button",
              {
                staticClass: "chat-send-button",
                on: { click: _vm.assignToMe }
              },
              [_c("i", { staticClass: "fa fa-link" })]
            )
          : _vm._e(),
        _vm.ticket.status == "ACTIVE" &&
        _vm.ticket.assigneeId != null &&
        _vm.ticket.assigneeId != undefined &&
        _vm.ticket.assigneeId === _vm.getProfile.id
          ? _c(
              "button",
              {
                staticClass: "chat-send-button",
                on: { click: _vm.sendMessage }
              },
              [_vm._v("✔")]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }